import { API, authClient } from "../index";

export const getUserMessages = (
  accessToken,
  status = "no_leidos",
  page = 1,
  limit = 25
) => authClient(accessToken).get(
  `${API}/messages?estado=${encodeURIComponent(status)}&pagina=${page}&limite=${limit}`
);

export const markUserMessageAsRead = (messageId, accessToken) =>
  authClient(accessToken).post(`${API}/messages/${messageId}/read`);

export const getUserMessageSubscriptions = (accessToken) =>
  authClient(accessToken).get(`${API}/messages/subscriptions`);

export const updateUserMessageSubscriptions = (subscriptions, accessToken) =>
  authClient(accessToken).put(`${API}/messages/subscriptions`, {
    suscripciones: subscriptions,
  });
